import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import { getStrapiMedia } from "../../../utils/utils";
import "./SliderUkraine.scss";

import { SliderComponent_Plain } from "../../../types/components/shared/SliderComponent.ts";
import { AccordionComponent } from "../../../types/components/page/AccordionComponent.ts";
import { useTranslation } from "react-i18next";

const SliderUkraine = ({
  data,
  tabs,
}: {
  data: SliderComponent_Plain;
  tabs: AccordionComponent[];
}) => {
  const { t } = useTranslation();
  const swiperRef = useRef(null);

  const tabsList = tabs.map((item, i: number) => (
    <a
      className="main-slider__tags-item"
      key={i}
      href={`#${item.id}`}
      onClick={(e) => {
        e.preventDefault();

        const productsSection = document.querySelector(".accordion-inf");
        if (productsSection) {
          productsSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }

        const tabElement = document.querySelector(
          `.tabs-nav__item[data-index="${i}"]`,
        );
        if (tabElement) {
          (tabElement as HTMLElement).click();
        }
      }}
      data-index={i}
    >
      {item.title}
    </a>
  ));

  /*const slides = data.map((item: SliderComponent_Plain, i: number) => (
    <SwiperSlide key={i} className="slider__item">
      {item.image ? (
        <img src={getStrapiMedia(item.image.url)} alt={item.title} />
      ) : (
        ""
      )}
      <div className="slider__text">
        <div className="slider__title">
          <div className="wrapper">{item.title}</div>
        </div>
        <div className="slider__subtitle">
          <div className="slider__subtitle-text">{item.description}</div>
        </div>
      </div>
    </SwiperSlide>
  ));*/
  const slides = (
    <SwiperSlide className="slider__item">
      {data.image ? (
        <img src={getStrapiMedia(data.image.url)} alt={data.title} />
      ) : (
        ""
      )}
      <div className="slider__text">
        <h1 className="slider__title">
          <div className="wrapper">{data.title}</div>
        </h1>
        <div className="slider__subtitle">
          <div className="slider__subtitle-text">{data.description}</div>
        </div>
      </div>
    </SwiperSlide>
  );

  return (
    <section className="main-slider main-slider__infoukraine">
      <div className="main-slider__tags">{tabsList}</div>
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, EffectFade]}
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        effect="fade"
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        onSwiper={(swiper) => {
          console.log("Swiper initialized", swiper);
        }}
        onSlideChange={(swiper) => {
          console.log("Slide changed", swiper.activeIndex);
        }}
        className="slider"
      >
        {slides}
      </Swiper>
      <a
        href="https://cabinet.d.trading/"
        target={"_blank"}
        className="btn-contact"
      >
        {t("Log in to your personal account")}
      </a>
    </section>
  );
};

export default SliderUkraine;
